<template>
  <div>
    <populate-form
      collapseStyle="simple"
      formTitle="電子票券搜尋處理"
      fkey="tm01"
      ref="filterForm"
      populateOptionVar="filterOptions"
      formDataObjVar="filterData"
      @customValueChanged="filterChanged"
    ></populate-form>
    <div class="wrapper2" ref="wrapper" @scroll="handleScroll">
      <b-table :stacked="checkMobile()" ref="scrollarea" class="" striped hover :items="items" :fields="fields" @scrolldownend="searchTickets(true)">
        <template slot="actions" slot-scope="row">
          <b-button v-if="row.item.confirm_use_status==='running'&&!row.item.in_reserving&&row.item.buyer_MI!=row.item.user_MI" @click="returnTicket(row.item)" size="sm" class="mr-1">
            手動強制還給原購人
          </b-button>
          <b-button @click="showDetail(row.item)">詳細</b-button>
        </template>
      </b-table>
    </div>
    <b-modal
      id="detailModal"
      ref="ticketModal"
      v-model="modalShow" 
      centered
      size="lg"
      hide-header
      hide-footer
      :static="true"
    >
      <populate-form
        formTitle="票券狀態詳細"
        fkey="ts01"
        ref="detailForm"
        populateOptionVar="detailOptions"
        :parentVue="this"
        formDataObjVar="detailData"
      />
    </b-modal>
  </div>
</template>

<script>

export default {
  name: 'TicketProcess',
  components: {
  
  },
  data: function () {
    return {
      detailData: {},
      detailOptions: [
        {
          componentType:"span",
          placeholder:"票號",
          col:2
        },
        {
          componentType:"text",
          akey:'ticket_no',
          placeholder:"",
          col:4,
          disabled:true
        },
        {
          componentType:"span",
          placeholder:"PI",
          col:2
        },
        {
          componentType:"text",
          akey:'product_id',
          placeholder:"",
          col:4,
          disabled:true
        },
        {
          componentType:"span",
          placeholder:"產票於",
          col:2
        },
        {
          componentType:"text",
          akey:'print_time',
          placeholder:"",
          col:4,
          disabled:true
        },
        {
          componentType:"span",
          placeholder:"訂單",
          col:2
        },
        {
          componentType:"text",
          akey:'bill_id',
          placeholder:"",
          col:4,
          disabled:true
        },
        {
          componentType:'span',
          col:2,
          placeholder:'使用狀態',
          title:"running:未使用 confirmed:已核銷 dispatching:分票待領取 cancelled:已退票 partial_used:多次使用已使用未用畢"
        },
        {
          componentType:'text',
          akey:'confirm_use_status',
          col:4,
          disabled:true
        },
        {
          componentType:"span",
          placeholder:"優惠期限",
          col:2
        },
        {
          componentType:'text',
          akey:'project_due_date',
          col:4,
          disabled:true
        },
        {
          componentType:"span",
          placeholder:"使用人",
          col:2
        },
        {
          componentType:'text',
          akey:'use_name',
          col:4,
          disabled:true
        },
        {
          componentType:"span",
          placeholder:"使用人MI",
          col:2
        },
        {
          componentType:'text',
          akey:'user_MI',
          col:4,
          disabled:true
        },
        {
          componentType:"span",
          placeholder:"使用人手機",
          col:2
        },
        {
          componentType:'text',
          akey:'user_mobile',
          col:4,
          disabled:true
        },
        {
          componentType:"span",
          placeholder:"使用人mail",
          col:2
        },
        {
          componentType:'text',
          akey:'user_email',
          col:4,
          disabled:true
        },
        {
          componentType:"span",
          placeholder:"購買人",
          col:2
        },
        {
          componentType:'text',
          akey:'buyer_name',
          col:4,
          disabled:true
        },
        {
          componentType:"span",
          placeholder:"購買人MI",
          col:2
        },
        {
          componentType:'text',
          akey:'buyer_MI',
          col:4,
          disabled:true
        },
        {
          componentType:"span",
          placeholder:"購買人手機",
          col:2
        },
        {
          componentType:'text',
          akey:'buyer_mobile',
          col:4,
          disabled:true
        },
        {
          componentType:"span",
          placeholder:"購買人mail",
          col:2
        },
        {
          componentType:'text',
          akey:'buyer_mail',
          col:4,
          disabled:true
        },
        {
          componentType:"span",
          placeholder:"使用時間",
          col:2
        },
        {
          componentType:'text',
          akey:'use_time',
          col:4,
          disabled:true
        },
        {
          componentType:"span",
          placeholder:"用於店家",
          col:2
        },
        {
          componentType:'text',
          akey:'used_in_store_name',
          col:4,
          disabled:true
        },
      ],
      filterData: {},
      filterOptions: [
        {
          componentType:'text',
          defaultValue:'',
          akey:'bill_id',
          col:3,
          placeholder:'訂單編號',
          execCallback:this.searchTickets,
        },
        {
          componentType:'text',
          defaultValue:'',
          akey:'member_id',
          col:3,
          placeholder:'使用者MI',
          execCallback:this.searchTickets,
        },
        {
          componentType:'text',
          defaultValue:'',
          akey:'from_member_id',
          col:3,
          placeholder:'購票人MI',
          execCallback:this.searchTickets,
        },
        {
          componentType:'b-form-select',
          akey:'confirm_use_status',
          col:3,
          defaultValue:'running',
          dataOptions:[{value:'running',text:'待使用'},{value:'confirmed',text:'已核銷'},{value:'dispatching',text:'分票待領中'},{value:'cancelled',text:'已退票'},{value:'partial_used',text:'已部分使用'}],
          placeholder:'篩選票券狀態',
          execCallback:this.searchTickets,
        },
        {
          componentType:'date-picker',
          defaultValue:'',
          akey:'print_from',
          col:3,
          placeholder:'搜尋產票日期起',
          execCallback:this.searchTickets,
        },
        {
          componentType:'date-picker',
          defaultValue:'',
          akey:'print_to',
          col:3,
          placeholder:'搜尋產票日期迄',
          execCallback:this.searchTickets,
        },
        {
          componentType:'text',
          akey:'ticket_no',
          defaultValue:'',
          col:3,
          placeholder:'用完整AA票號找',
          execCallback:this.searchTickets,
        },
        {
          componentType:'text',
          akey:'line_code',
          defaultValue:'',
          col:3,
          placeholder:'用酷券條碼找',
          execCallback:this.searchTickets,
        },
        {
          componentType:'text',
          akey:'product_id',
          defaultValue:'',
          col:3,
          placeholder:'用商品PI找',
          execCallback:this.searchTickets,
        },
        {
          componentType:'span',
          col:6,
        },
        {
          componentType:'b-button',
          col:3,
          placeholder:"搜尋",
          execCallback:this.searchTickets
        }
      ],
      showFilter: true,
      Merchants: [],
      SelectedMerchantId: null,
      SelectedMerchantItem: Object,
      SelectedMerchant: Object,
      QueryStartDate: null,
      QueryEndDate: null,
      modalShow: false,
      editingRow: {},
      editingIndex: 0,
      items: [],
      pageNumber:0,
      itemsPerPage:50,
      hasMore:true,
      isLoading:false,
      fields: [
        {
          key: 'product_id',
          label: 'PI',
          sortable: false
        },
        {
          key: 'ticket_project_name',
          label: '課程名稱',
          sortable: false
        },
        {
          key: 'use_name',
          label: '使用者',
          sortable: false
        },
        {
          key: 'ticket_no',
          label: '票號',
          sortable: true
        },
        {
          key:'confirm_use_status',
          label:'使用狀態',
        },
        {
          key: 'actions',
          label: '功能'
        }
      ]
    }
  },
  methods: {
    handleScroll(evt) {
      // 僅偵測垂直scroll時是否scroll位置到達95%的位置,是則觸發事件(不能由div觸發需要被捲的組件觸發與偵測＝＝)
      //if ((evt.target.scrollTop/(evt.target.scrollHeight-evt.target.clientHeight)) > 0.95) {
      // 只能把計算邏輯抽到$bus而已,需要this.$refs.scrollarea這個沒辦法丟過去(若為此要把wrapper寫成獨立組件又太麻煩先這樣吧)
      if (this.calScrollRatio(evt) > 0.95) {
        this.$refs.scrollarea.$emit('scrolldownend')
      }
    },
    filterChanged (upd) {
      if (['confirm_use_status'].includes(upd.key)) {
        setTimeout(() => {
          this.searchTickets()
        }, 50);
      }
    },
    searchTickets(append = false) {
      if (append === true) {
        if (!this.hasMore || this.isLoading) {
          return
        }
        this.pageNumber ++
      }
      else {
        this.pageNumber = 1
        this.hasMore = true
        this.$refs.wrapper.scrollTop = 0
      }
      let Param = {
        'module':'customer_service',
        'method':'csSearchTicketList',
        'bill_id': this.filterData.bill_id,
        'member_id': this.filterData.member_id,
        'from_member_id': this.filterData.from_member_id,
        'print_from': this.filterData.print_from,
        'print_to': this.filterData.print_to,
        'ticket_no': this.filterData.ticket_no,
        'line_code': this.filterData.line_code,
        'product_id': this.filterData.product_id,
        'filter_status': this.filterData.confirm_use_status,
        'page_number':this.pageNumber,
        'items_per_page':this.itemsPerPage,
      }
      this.isLoading = true
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
          vm.$bus.fnShowInfo(data.msg)
          return
        }
        if (vm.pageNumber === 1) {
          vm.items = data.data
        }
        else {
          vm.items = vm.items.concat(data.data)
        }
        if (data.data.total <= vm.items.length) {
          vm.hasMore = false
        }
        vm.isLoading = false
      }, this)
    },
    returnTicket(ticket) {
      this.$bus.fnShowConfirm(('強制歸還此票券給原購者？'),() => {
        let Param = {
          'module':'customer_service',
          'method':'csReturnDispatchedTicket',
          'ticket_item_id':ticket.ticket_item_id
        }
        this.$bus.apiCall(Param, function (data, vm) {
          if (data.ok === 0) {
            vm.$refs.detailForm.showAlert(data.msg)
            return
          }
          vm.$bus.fnClosePopup()
          vm.$bus.fnShowInfo("已完成"+ticket.ticket_no+"的歸還原購人操作")
          vm.searchTickets()
          return
        }, this)
      }, () => {
        this.$bus.fnClosePopup()
        return 
      })
    },
    showDetail: function (row) {
      this.detailData = this.CpObj(row)
      this.modalShow = true
    },
    modalOK: function (doneCB) {
      if (!this.formData.service_standard_minutes || !this.formData.project_start_date || !this.formData.project_end_date) {
        this.$refs.editForm.triggerAlert("請檢查必填欄位")
        doneCB()
        return
      }
      let Param = {
        'module':'admin_manage',
        'method':'setup_merchant_ticket',
        'ticket_project_id': this.formData.ticket_project_id,
        'service_standard_minutes': this.formData.service_standard_minutes,
        'service_assert_minutes': this.formData.service_assert_minutes,
        'service_quota': 1,
        'usage_limit_per_user': 1,
        'project_start_date': this.formData.project_start_date,
        'project_end_date': this.formData.project_end_date,
        'project_extend_date': this.formData.project_extend_date?this.formData.project_extend_date:''
      }
      //service_assert_minutes只有create時才傳input的值就好,edit時帶舊值
      if (!this.formData.ticket_project_confirmed) {
        Param.service_assert_minutes = this.formData.service_standard_minutes
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$refs.editForm.triggerAlert(data.msg)
            doneCB()
            return
          }
          if (vm.formData.service_items.length > 0) {
            vm.formData.service_items[0].service_standard_minutes = parseInt(vm.formData.service_standard_minutes)
            vm.formData.service_items[0].service_assert_minutes = parseInt(vm.formData.service_standard_minutes)
          }
          else {
            vm.formData.service_items.push({'service_standard_minutes':parseInt(vm.formData.service_standard_minutes),'service_assert_minutes':parseInt(vm.formData.service_standard_minutes)})
          }
          // 成功時無論如何都是已確認(由未設定變已設定 或已設定的更新)
          vm.formData.ticket_project_confirmed = 1
          vm.items[vm.editingIndex] = vm.CpObj(vm.formData)
          vm.items = vm.CpObj(vm.items)
          doneCB()
          vm.modalShow = false
          vm.$bus.fnShowInfo('設定完成')
      }, this)
    },
    modalCancel: function () {
      this.modalShow = false
    },
  },
  created() {
    
  },
  mounted() {
    this.$refs.filterForm.initDefault()
    setTimeout(() => {
      this.$refs.detailForm.initDefault()
    }, 100);
    this.searchTickets()
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.wrapper2 {
  height: 65vh;
  overflow-y: scroll;
  border-style: inset;
}

</style>
